import { NOTIFICATION_FEATURE_KIND, NOTIFICATION_TYPE_KEYS, parseNotificationFlag } from './constants.js';

/** Whether a setup/cycle notification is enabled (matches form `flag !== false` + API status strings). */
export function isNotificationEnabled(doc = {}) {
  return parseNotificationFlag(doc.status, doc.flag, true);
}

const FEATURE_ALIASES = {
  dashboard: NOTIFICATION_TYPE_KEYS.DASHBOARD,
  Dashboard: NOTIFICATION_TYPE_KEYS.DASHBOARD,
  taskoverduenotification: NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION,
  taskOverDueNotification: NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION,
};

/**
 * Resolve notification feature key from API/store shapes (legacy + master templates).
 */
export function resolveNotificationFeature(doc = {}) {
  const raw = doc.feature ?? doc.notificationFeature ?? doc.notificationType ?? '';
  const key = String(raw).trim();
  if (FEATURE_ALIASES[key]) return FEATURE_ALIASES[key];
  if (NOTIFICATION_FEATURE_KIND[key]) return key;

  const hasDashboardShape = doc.mailBody != null
    && doc.subject != null
    && doc.meta?.category == null
    && doc.meta?.sla == null;
  if (hasDashboardShape) return NOTIFICATION_TYPE_KEYS.DASHBOARD;

  const hasEscalationShape = doc.meta?.category != null || doc.meta?.sla != null;
  if (hasEscalationShape && !doc.mailBody) return NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION;

  return key || raw;
}

export function normalizeNotificationRecord(doc) {
  if (!doc || typeof doc !== 'object') return doc;
  const feature = resolveNotificationFeature(doc);
  const kind = doc.kind || (feature ? NOTIFICATION_FEATURE_KIND[feature] : null) || doc.kind;
  const enabled = isNotificationEnabled(doc);
  return {
    ...doc,
    ...(feature ? { feature } : {}),
    ...(kind ? { kind } : {}),
    flag: enabled,
  };
}

export function normalizeNotificationList(list) {
  if (!Array.isArray(list)) return [];
  return list.map((item) => normalizeNotificationRecord(item));
}
